import { useEffect, useRef, useState } from "react";
import styles from "./promptInfo.module.scss";
import { HandySvg } from "handy-svg";

const PromptInfo = ({ prompt }) => {
  const [open, setOpen] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const PromptInfoWrapperRef = useRef(null);

  const handleClickOutside = () => {
    navigator.clipboard.writeText(prompt)
    setIsCopy(true);

    setTimeout(() => {
      setIsCopy(false);
    }, 3000);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (PromptInfoWrapperRef.current && !PromptInfoWrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return <div ref={PromptInfoWrapperRef} className={styles.container}>
    <button onClick={() => setOpen(!open)} className={styles.btn}>i</button>


    <div className={`${styles.info} ${open ? styles.open : styles.close}`}>
      <p className={styles.text}><b>Prompt:</b> {prompt}</p>
      <button onClick={handleClickOutside} className={styles.copy_btn}>
        {isCopy ? <HandySvg src={"/survey/done.svg"} width={24} height={24} /> : <HandySvg src={"/survey/copy.svg"} width={24} height={24} />}
      </button>
    </div>

  </div>;
};

export default PromptInfo;